module.exports = __webpack_public_path__ + "assets/img/icon-maopucar.a001ab14.png";